import { getCMSWebViewPermissionsPanelV2Url } from './cms-web-panels'

export default async function ({
  hostname,
  editorSdkProxy,
  collectionId,
  logger,
}) {
  const url = await getPanelUrl({
    hostname,
    editorSdkProxy,
  })

  const dimensions = getPanelDimensions()

  await editorSdkProxy.editor
    .openModalPanel({
      url,
      shouldHideHeader: true,
      ...dimensions,
      initialData: {
        collectionId,
      },
    })
    .catch(error => {
      logger.error(
        new Error('Failed to open collection permissions panel', {
          cause: error,
        }),
      )
    })
}

function getPanelUrl({ hostname, editorSdkProxy }) {
  return getCMSWebViewPermissionsPanelV2Url({ hostname, editorSdkProxy })
}

function getPanelDimensions() {
  return { width: 744, height: 462 }
}
